import React, { useEffect, useState } from "react";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import { showMessage } from "../../Functionalities/Functions";
import { ManageNotification } from "./Logic";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css
import { ManageProducts, ManageRestaurant, ManageBranchOffers, ManageOffers } from '../../Functionalities/Functions'
import { ManageFranchise } from '../Franchise/Logic'
import { is_superuser, picked_franchise_id, sees_all_franchises } from '../../Functionalities/Config'
import Dropdown from "../../CoreComponents/Dropdown";
import ImageUploadWithCrop from "../../CoreComponents/ImageUploadWithCrop";
function Body() {
    // const [image, setImage] = useState("")
    const [data, setData] = useState({
        title: "",
        message: "",
        image: "",
        keyword: "",
        item_off_id: "",
        branch_off_id: "",
        item_id: "",
        branch_id: "",
        target: "customers",
        include_off_duty: true,
        franchise_id: picked_franchise_id
    });
    const [franchises, setfranchises] = useState([])
    const [radio, setradio] = useState({
        product: false,
        restaurant: false,
        product_offer: false,
        restaurant_offer: false,
        normal_notification: true
    })
    const [products, setproducts] = useState([])
    const [product, setproduct] = useState("")
    const [branch, setbranch] = useState("")

    const [restaurants, setrestaurants] = useState([])
    const [restaurant, setrestaurant] = useState("")


    const [productOffers, setproductOffers] = useState([])
    const [selectedPdtOffer, setselectedPdtOffer] = useState("")

    const [restaurantOffers, setrestaurantOffers] = useState([])
    const [selectedRestaurantOffer, setselectedRestaurantOffer] = useState("")
    const [id, setId] = useState(new Date())

    const [compression, setCompression] = useState(true)
    const [started, setStarted] = useState(false)


    useEffect(() => {
        if (!sees_all_franchises) return;
        ManageFranchise("", "", "get", "page_wise=false&for_dropdown=1")
            .then((result) => {
                setfranchises(Array.isArray(result?.data) ? result.data : [])
            })
            .catch(() => {
                setfranchises([])
            })
    }, [])

    const [errors, setErrors] = useState([]);
    useEffect(() => {
        if (errors.length > 0) {
            showMessage(
                errors[0],
                "danger",
                "Following fields required!",
                "top",
                "top-right",
                0
            );
        }
    }, [errors]);

    useEffect(() => {
        if (radio.product) {
            
            
            getRestaurants()
            // if (restaurant != "") {
            //     getProducts()
            // }

        }
        // if (radio.restaurant) {
        //     getRestaurants()
        // }
        if (radio.product_offer) {
            getAllProductOffer()
        }
        if (radio.restaurant_offer) {
            getAllRestaurantOffer()
        }
    }, [radio])
    useEffect(() => {
        getProducts()
    }, [branch])
    const getProducts = () => {
        let result = ManageProducts("", "", "get", `for_dropdown=true&order_by_name=true&my_branch=true&page_wise=0&branch_id=${branch}`);
        result.then((result) => {
            setproducts(result.data);
        });
    }
    const getRestaurants = () => {
        let params = "for_dropdown=true&page_wise=false&blocked_out_drop_down=true&order_by_name=true";
        let result = ManageRestaurant("", "", "get", params);
        result
            .then((result) => {
                setrestaurants(
                    result.data,
                );
            })
    }
    const getAllProductOffer = () => {
        let result = ManageOffers("", "", "get", "offer_type=item");
        result.then((result) => {
            setproductOffers(
                result.data.results,
            );

        })
            .catch((err) => {

                // void 0
            });
    }
    const getAllRestaurantOffer = () => {
        let result = ManageBranchOffers("", "", "get", "offer_type=branch");
        result
            .then((result) => {

                setrestaurantOffers(
                    result.data.results,
                );

            })
            .catch((err) => {

            });

    }
    return (
        <div>
            <div class="content-body">
                <div class="container-fluid">
                   

                    <div className="col-lg-12">
                        {started ?
                        <div className="d-flex flex-column col-12 align-items-center justify-content-center vh-100">
                            <div class="loader">
                            </div>
                            <span className="mt-2 fs-20">
                                Sending notification..
                            </span>
                        </div>: 
                        <div className="card">
                            <div className="card-body"
                                style={{ display: "flex", align: "center", justifyContent: "center " }}
                            >
                                <form>
                                    <div className="form-group mb-3">
                                        <label className="radio-inline mr-5">
                                            <input type="radio" checked={data.target === "customers"}
                                                onChange={() => {
                                                    setData({ ...data, target: "customers" });
                                                }}
                                            />{" "} Customers</label>
                                        <label className="radio-inline mr-5">
                                            <input type="radio" checked={data.target === "delivery_boys"}
                                                onChange={() => {
                                                    setData({ ...data, target: "delivery_boys", keyword: "" });
                                                    setradio({
                                                        normal_notification: true,
                                                        product: false,
                                                        restaurant: false,
                                                        product_offer: false,
                                                        restaurant_offer: false,
                                                    });
                                                }}
                                            />{" "} Delivery partners</label>
                                        {data.target === "delivery_boys" && (
                                            <label className="checkbox-inline ml-3">
                                                <input type="checkbox" checked={data.include_off_duty}
                                                    onChange={(e) => {
                                                        setData({ ...data, include_off_duty: e.target.checked });
                                                    }}
                                                />{" "} Include riders who are off duty
                                            </label>
                                        )}
                                    </div>
                                    {data.target === "customers" && <div className="form-group mb-0">
                                        <label className="radio-inline mr-5">
                                            <input type="radio" checked={radio.normal_notification}
                                                value={radio.normal_notification}
                                                onChange={(e) => {
                                                    setradio({
                                                        ...radio,
                                                        normal_notification: true,
                                                        product: false,
                                                        restaurant: false,
                                                        product_offer: false,
                                                        restaurant_offer: false,
                                                    });
                                                }}
                                            />{" "} Normal</label>
                                        <label className="radio-inline mr-5">
                                            <input type="radio" value={radio.product} checked={radio.product}
                                                onChange={(e) => {
                                                    setradio({
                                                        ...radio,
                                                        normal_notification: false,
                                                        product: true,
                                                        restaurant: false,
                                                        product_offer: false,
                                                        restaurant_offer: false,
                                                    });
                                                }}
                                            />{" "} Product/Restaurant </label>
                                        {/* <label className="radio-inline mr-5">
                                            <input type="radio" value={radio.restaurant} checked={radio.restaurant}
                                                onChange={(e) => {
                                                    setradio({
                                                        ...radio,
                                                        normal_notification: false,
                                                        product: false,
                                                        restaurant: true,
                                                        product_offer: false,
                                                        restaurant_offer: false,
                                                    });

                                                }}
                                            />{" "} Restaurant </label> */}
                                        <label className="radio-inline mr-5">
                                            <input type="radio" value={radio.product_offer}
                                                checked={radio.product_offer}
                                                onChange={(e) => {
                                                    setradio({
                                                        ...radio,
                                                        normal_notification: false,
                                                        product: false,
                                                        restaurant: false,
                                                        product_offer: true,
                                                        restaurant_offer: false,
                                                    });

                                                }}
                                            />{" "} Product Banner </label>
                                        <label className="radio-inline mr-5">
                                            <input type="radio" value={radio.restaurant_offer}
                                                checked={radio.restaurant_offer}
                                                onChange={(e) => {
                                                    setradio({
                                                        ...radio,
                                                        normal_notification: false,
                                                        product: false,
                                                        restaurant: false,
                                                        product_offer: false,
                                                        restaurant_offer: true,
                                                    });
                                                }}
                                            />{" "} Restaurant Banner </label>
                                    </div>}
                                </form>
                            </div>

                            <div className="card-body">
                                <div className="basic-form">
                                    <form>
                                        {
                                            !radio.normal_notification &&
                                                (radio.product)
                                                ?
                                                <div>
                                                    <div class="form-group row">
                                                        <label className="col-sm-3 col-form-label">Restaurant <span className="required">*</span>
                                                        </label>
                                                        <div class="col-sm-9">
                                                            <select
                                                                value={branch}
                                                                class="form-control form-control-lg "
                                                                onChange={(e) => {
                                                                    setbranch(e.target.value)
                                                                    setData({ ...data, branch_id: e.target.value, keyword: "branch" })
                                                                }}>
                                                                <option value={""}>---select restaurant---</option>

                                                                {
                                                                    restaurants.length > 0 && restaurants.map(item => {
                                                                        return <option value={item.id}>{item.name}</option>
                                                                    })
                                                                }
                                                            </select></div>
                                                    </div >

                                                    {
                                                        branch != "" &&
                                                        <div class="form-group row">
                                                            <label className="col-sm-3 col-form-label">Product <span className="required">*</span>
                                                            </label>
                                                            <div class="col-sm-9">
                                                                <select
                                                                    value={product}
                                                                    class="form-control form-control-lg "
                                                                    onChange={(e) => {
                                                                        setData({ ...data, item_id: e.target.value, keyword: "item" });
                                                                        setproduct(e.target.value)
                                                                    }}>
                                                                    <option value={""}>---select product---</option>

                                                                    {
                                                                        products.length > 0 && products.map(item => {
                                                                            return <option value={item.id}>{item.name}</option>
                                                                        })
                                                                    }
                                                                </select></div>
                                                        </div >
                                                    }
                                                </div>
                                                :
                                                // radio.restaurant ?
                                                //     <Dropdown
                                                //         keyword="restaurant"
                                                //         data={restaurants}
                                                //         value={restaurant}
                                                //         onChange={(e) => {

                                                //             setData({ ...data, branch_id: e.target.value, keyword: "branch" });
                                                //             setrestaurant(e.target.value)


                                                //         }}
                                                //     />:

                                                radio.product_offer ?
                                                    <Dropdown
                                                        keyword={"product_offer"}
                                                        data={productOffers}
                                                        value={selectedPdtOffer}
                                                        onChange={(e) => {
                                                            setData({ ...data, item_off_id: e.target.value, keyword: "item_offer" });
                                                            setselectedPdtOffer(e.target.value)
                                                        }}
                                                    /> :
                                                    radio.restaurant_offer &&
                                                    <Dropdown
                                                        keyword={"restaurant_offer"}
                                                        data={restaurantOffers}
                                                        value={selectedRestaurantOffer}
                                                        onChange={(e) => {
                                                            setData({ ...data, branch_off_id: e.target.value, keyword: "branch_discount" });
                                                            setselectedRestaurantOffer(e.target.value)
                                                        }}
                                                    />
                                        }

                                        {sees_all_franchises && <div className="form-group row">
                                            <label className="col-sm-3 col-form-label">Franchise</label>
                                            <div className="col-sm-9">
                                                <select
                                                    className="form-control"
                                                    value={data.franchise_id}
                                                    onChange={(e) => {
                                                        setData({ ...data, franchise_id: e.target.value });
                                                    }}
                                                >
                                                    <option value="">Select franchise</option>
                                                    {franchises.map((item) => (
                                                        <option key={item.id} value={item.id}>{item.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>}

                                        <div className="form-group row">
                                            <label className="col-sm-3 col-form-label">Title</label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={data.title}
                                                    onChange={(e) => {
                                                        setData({ ...data, title: e.target.value });
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <label className="col-sm-3 col-form-label">Message</label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={data.message}
                                                    onChange={(e) => {
                                                        setData({ ...data, message: e.target.value });
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-sm-3 col-form-label">Image
                                                <br/>
                                                <b>Compress image {" "}</b>
                                                <input type="checkbox" checked={compression} onChange={(e) => {setCompression(e.target.checked);setData({...data,image:""})}}/> 
                                            </label>
                                            <div className="col-sm-9">
                                                <ImageUploadWithCrop
                                                    value={data.image}
                                                    onChange={(file) =>
                                                        setData({
                                                            ...data,
                                                            image: file,
                                                        })
                                                    }
                                                    aspectRatio={1}
                                                    compress={compression}
                                                    compressMaxRes={382}
                                                />
                                            </div>
                                        </div>




                                        <div className="form-group row">
                                            <div className="col-sm-9">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary"
                                                    onClick={(e) => {
                                                        var img = data.image
                                                        e.preventDefault();
                                                        setErrors([]);
                                                        if ((radio.product) && (data.branch_id === "")) {
                                                            setErrors(["Product/Restaurant"]);
                                                            return;
                                                        }
                                                        // if ((radio.restaurant) && (data.branch_id === "")) {
                                                        //     setErrors(["Restaurant"]);
                                                        //     return;
                                                        // }
                                                        if ((radio.product_offer) && (data.item_off_id === "")) {
                                                            setErrors(["Product Offer"]);
                                                            return;
                                                        }
                                                        if ((radio.restaurant_offer) && (data.branch_off_id === "")) {
                                                            setErrors(["Restaurant Offer "]);
                                                            return;
                                                        }


                                                        if (data.title === "") {
                                                            setErrors(["Notification Title"]);
                                                            return;
                                                        }

                                                        if (data.message === "") {
                                                            setErrors(["Notification Message"]);
                                                            return;
                                                        }
                                                        if (is_superuser && data.franchise_id === "") {
                                                            setErrors(["Franchise"]);
                                                            return;
                                                        }
                                                        // alert(JSON.stringify(data))
                                                        // alert(JSON.stringify(image))


                                                        confirmAlert({
                                                            customUI: ({ onClose }) => {
                                                                return (
                                                                    <div className='custom-ui' style={{ borderRadius: 8, border: 'solid', padding: 70, borderWidth: 0.5 }}>
                                                                        <h1>Are you sure to send?</h1>
                                                                        {/* <p>You want to send ?</p> */}
                                                                        {/* <p>{data.title}</p>
                                                                        <p>{data.message}</p> */}

                                                                        <button onClick={onClose} className="btn btn-primary" style={{ marginRight: 10, }}>Cancel</button>
                                                                        {
                                                                        <button
                                                                            onClick={() => {
                                                                                setStarted(true)
                                                                                onClose()
                                                                                

                                                                                let result = ManageNotification(e, data, "add", "");
                                                                                result.then((result) => {
                                                                                    if (result.data.Status === true) {
                                                                                        // alert("success");
                                                                                        setStarted(false)
                                                                                        showMessage("Notification sent", "success", "Success!", "top", "top-right", 0)
                                                                                        setData({
                                                                                            ...data,
                                                                                            title: "",
                                                                                            message: "",
                                                                                            image: "",
                                                                                            keyword: "",
                                                                                            item_off_id: "",
                                                                                            branch_off_id: "",
                                                                                            item_id: "",
                                                                                            branch_id: ""
                                                                                        })

                                                                                        setbranch("")
                                                                                        setproduct("")
                                                                                        setselectedPdtOffer("")
                                                                                        setselectedRestaurantOffer("")
                                                                                        setId(new Date())
                                                                                        
                                                                                        // window.location.reload();
                                                                                    } else {
                                                                                        setStarted(false)
                                                                                        showMessage(result.data.Error, "danger", "Error!", "top", "top-right", 0)
                                                                                    }
                                                                                }).catch(err => {
                                                                                    setStarted(false)
                                                                                    showMessage("Error", "danger", "Error!", "top", "top-right", 0)
                                                                                })
                                                                            }}
                                                                            className="btn btn-primary"
                                                                            >
                                                                            Send  
                                                                        </button>}
                                                                    </div>
                                                                );
                                                            }
                                                        });


                                                    }}
                                                >
                                                    Send
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
        </div>
    );
}

function Notification() {
    return (
        <div>
            <div id="main-wrapper">
                <MainHeader />

                <Header name={"Notification"} subHeading={"send notification here"} />
                <NavBar />
                <Body />
                <Footer />
            </div>
        </div>
    );
}

export default Notification;
